import { fmtDate, strDate2Server } from "../../extensions/utils";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { message, Table, Spin, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { isMobile, menuSize } from "@/extensions/design";
const { Text } = Typography;

const StockCard = ({id, begPeriod, endPeriod, onClose, productName, productUnit}) => {
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const maxHeight = window.innerHeight - menuSize - 95;
  const rowHeight = 54; // высота одной записи
  const numRows = item?.movements?.length ?? 0;

  // Либо весь список, либо максимальная высота
  const listHeight = Math.min(numRows * rowHeight, maxHeight);

  const getData = () => {
    setLoading(true);
    serverFetch(`store/MovementCard?productId=${id}&startDate=${strDate2Server(begPeriod)}&endDate=${strDate2Server(endPeriod)}`)
      .then(data => {
        let qty = data.initialBalance;
        data.movements.sort((a, b) => new Date(a.moveDate) - new Date(b.moveDate));
        data.movements.forEach(i => {
          qty += i.quantity;
          i.rest = qty;
        });
        data.finalBalance = qty;
        setItem(data);
        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [id, begPeriod, endPeriod]);

  const columns = [
    { dataIndex: "moveDate", title: "Дата", render: fmtDate },
    { dataIndex: "quantity", title: "Количество", align: "right" },
    { dataIndex: "documentType", title: "Документ", },
    { dataIndex: "documentNumber", title: "#", align: "right" },
    { dataIndex: "rest", title: "Остаток", align: "right" },
  ]

  return !isMobile ? (<div>
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Карта товара</span>
          <CloseOutlined className="sport-section-title-close" onClick={onClose} style={{ zIndex: 9 }}   />
        </div>
        <div className="sport-section">
          {productName && <div style={{ marginBottom: 8 }}>
            <strong>{productName}</strong>{productUnit ? `, ${productUnit}` : ""}
          </div>}
          {item && <strong>Остаток на {fmtDate(begPeriod)}: {item.initialBalance}</strong>}
          {item && <Table dataSource={item.movements} loading={loading} columns={columns} pagination={false} size="small" rowKey="productId" />}
          {item && <strong>Остаток на {fmtDate(endPeriod)}: {item.finalBalance}</strong>}
        </div>
      </div>
    </div>
  </div>) : (
    <>
      <div className="sport-modal">
        <div className="sport-modal-overlay">
          <div className="sport-modal-content">
            <div className="sport-modal-title">
              <span>Карта товара</span>
              <CloseOutlined onClick={() => onClose(false)} className="sport-section-title-close client-close-outlined-button-style"/>
            </div>
            <div className="sport-section">
              {productName && <div style={{ marginTop: "4px", marginBottom: "4px" }}>
                <strong>{productName}</strong>
              </div>}
              {loading && (
                <div className="report-loading">
                  <Spin size="large" />
                </div>
              )} 
              {item && !loading && <Text> Остаток на {fmtDate(begPeriod)}: <strong>{item.initialBalance} {productUnit ? `${productUnit}` : ""}</strong></Text>}
              <div style={{ height: listHeight, overflowY: numRows * rowHeight > maxHeight ? "auto" : "visible",}} className="stock-scrollable-list">
                {item?.movements?.map((move) => (
                  <div key={move.documentNumber} className="client-item-sale" style={{backgroundColor:""}}>
                    <div className="client-item-body">
                      <div className="stock-osv-item-line-triple ">
                        <Text>{fmtDate(move.moveDate)}</Text>
                        <Text style={{textAlign: "center"}}> Кол-во: <strong>{move.quantity}</strong></Text>
                        <Text style={{textAlign: "right"}}> #{move.documentNumber} </Text>
                      </div>

                      <div className="stock-osv-item-line-double">
                        <Text>Документ: {move.documentType}</Text>
                        <Text style={{textAlign:"right"}}> Остаток: <strong>{move.rest}</strong></Text>
                      </div>
                    </div>
                  </div>
                ))}
                {(item?.movements?.length === 0 && !loading) ?
                  <div className="stock-no-data-text">Нет данных
                  </div> : <></>}
              </div>
              {item && <Text style={{marginTop: "8px"}}>Остаток на {fmtDate(endPeriod)}: <strong>{item.finalBalance} {productUnit ? `${productUnit}` : ""}</strong></Text>}
            </div>
            </div>
          </div>
        </div>
    </>
  )
}

export default StockCard;